// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"7d64cd6a","292":"98318147","402":"98318147","632":"98318147","649":"98318147","748":"98318147","765":"98318147","901":"98318147","965":"98318147"}[chunkId] + ".chunk.css";
};